import { render, staticRenderFns } from "./DefinitionEditorSurveyResultSpecific.vue?vue&type=template&id=1d3f3480"
import script from "./DefinitionEditorSurveyResultSpecific.vue?vue&type=script&lang=ts"
export * from "./DefinitionEditorSurveyResultSpecific.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports